import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { localForage } from '../../../js/api/encrypt.js';
import { loadStripe } from "@stripe/stripe-js";
import themes from '../../../js/stores/theme.js';
import language from '../../../js/stores/language.js';
import carLoan from '../../../js/stores/car-loan.js';
import loanInvoices from '../../../js/stores/loan-invoices.js';
import file from '../../../js/stores/file.js';
import UserSignArea from './user-sign-area.f7.html';
var PaymentTab = function PaymentTab(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $onBeforeUnmount = _ref.$onBeforeUnmount;
  var theme = themes.getters.Name.value;
  var locale = language.getters.Item.value;
  var data = props.data;
  var clientSecret = {};
  var stripe;
  var elements;
  var isPaymentGood = false;
  var invoiceDetails = [];
  var canvas = null;
  var popupPayment;
  var verifyImage = function verifyImage(value) {
    canvas = value.detail;
  };
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var dataToSend, result;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(data.CarLoanData.CarLoanStatusId != 2)) {
            _context.next = 1;
            break;
          }
          console.log('Not a payable car loan');
          return _context.abrupt("return");
        case 1:
          if (!(Number(data.CarLoanData.InvoiceId) > 0)) {
            _context.next = 3;
            break;
          }
          dataToSend = {
            invoiceId: data.CarLoanData.InvoiceId,
            languageCode: language.getters.Name.value
          };
          _context.next = 2;
          return loanInvoices.dispatch('getDetailsLocalized', dataToSend);
        case 2:
          result = _context.sent;
          if (result.status !== undefined && result.status !== 200) {
            console.log(result.data.messages.error);
          }
          invoiceDetails = result;
        case 3:
          popupPayment = $f7.popup.create({
            el: '.payment-popup',
            swipeToClose: true
          });
          $update();
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  $onBeforeUnmount(function () {
    if (popupPayment) popupPayment.destroy();
  });
  var openPaymentPopup = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(canvas == null)) {
              _context2.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.signImage.noSignMessage')
            });
            return _context2.abrupt("return");
          case 1:
            popupPayment.open();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function openPaymentPopup() {
      return _ref3.apply(this, arguments);
    };
  }();
  var onPopUpOpen = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var formData, result, appearance, paymentElementOptions, paymentElement;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            $f7.preloader.show();
            formData = new FormData();
            formData.append("CarLoanId", data.CarLoanData.CarLoanId);
            formData.append("CarId", data.CarMainData.CarId);
            formData.append("LenderId", data.CarMainData.ContactId);
            formData.append("BorrowerId", data.CarLoanData.BorrowerId);
            _context3.next = 1;
            return carLoan.dispatch('createPaymentIntent', formData);
          case 1:
            result = _context3.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context3.next = 2;
              break;
            }
            $f7.preloader.hide();
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context3.abrupt("return");
          case 2:
            _context3.next = 3;
            return loadStripe(process.env.STRIPE_KEY);
          case 3:
            stripe = _context3.sent;
            appearance = {
              theme: theme != 'dark' ? 'flat' : 'night',
              labels: 'floating'
            };
            clientSecret = result.clientSecret;
            elements = stripe.elements({
              clientSecret: clientSecret,
              appearance: appearance
            });
            paymentElementOptions = {
              layout: "tabs"
            };
            paymentElement = elements.create('payment', paymentElementOptions);
            paymentElement.mount("#payment-element");
            $f7.preloader.hide();
            $update();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onPopUpOpen() {
      return _ref4.apply(this, arguments);
    };
  }();
  var onPopUpClose = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var pid, formData, result;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!isPaymentGood) {
              _context4.next = 1;
              break;
            }
            return _context4.abrupt("return");
          case 1:
            $f7.preloader.show();
            pid = clientSecret.substring(0, 27);
            formData = new FormData();
            formData.append("ClientSecret", pid);
            _context4.next = 2;
            return carLoan.dispatch('cancelPaymentIntent', formData);
          case 2:
            result = _context4.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context4.next = 3;
              break;
            }
            $f7.preloader.hide();
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context4.abrupt("return");
          case 3:
            $f7.toast.show({
              text: locale.translate('loan.payment.messageStripePaymentStatus', [result.paymentStatus]),
              closeTimeout: 5000
            });
            $f7.preloader.hide();
            $update();
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function onPopUpClose() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var token, textUrl, dataURL, signData, saveSign, _yield$stripe$confirm, error, paymentIntent, obj;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            $f7.preloader.show();
            _context5.next = 1;
            return localForage.getItem('token');
          case 1:
            token = _context5.sent;
            textUrl = "".concat(process.env.END_POINT_URL, "/");
            textUrl += "post-payment-process/".concat(token, "/");
            textUrl += "".concat(data.CarLoanData.CarLoanId, "/").concat(data.CarMainData.CarId, "/");
            textUrl += "".concat(data.CarMainData.ContactId, "/").concat(data.CarLoanData.BorrowerId);
            dataURL = canvas;
            signData = {
              referenceId: data.CarLoanData.CarLoanId,
              image: dataURL
            };
            _context5.next = 2;
            return file.dispatch('saveBorrowerSignImage', signData);
          case 2:
            saveSign = _context5.sent;
            if (!(saveSign.status !== undefined && saveSign.status !== 201)) {
              _context5.next = 3;
              break;
            }
            $f7.preloader.hide();
            $f7.toast.show({
              text: saveSign.data.messages.error
            });
            return _context5.abrupt("return");
          case 3:
            _context5.next = 4;
            return stripe.confirmPayment({
              elements: elements,
              confirmParams: {
                return_url: textUrl
              },
              redirect: 'if_required'
            });
          case 4:
            _yield$stripe$confirm = _context5.sent;
            error = _yield$stripe$confirm.error;
            paymentIntent = _yield$stripe$confirm.paymentIntent;
            if (!error) {
              _context5.next = 5;
              break;
            }
            $f7.preloader.hide();
            $f7.toast.show({
              text: error.message,
              closeTimeout: 5000
            });
            return _context5.abrupt("return");
          case 5:
            $f7.preloader.hide();
            isPaymentGood = true;
            $f7.popup.close('.payment-popup', true);
            obj = {
              props: {
                clientSecret: clientSecret,
                data: {
                  CarLoanId: data.CarLoanData.CarLoanId,
                  CarId: data.CarMainData.CarId,
                  LenderId: data.CarMainData.ContactId,
                  BorrowerId: data.CarLoanData.BorrowerId
                }
              }
            };
            $f7.views.main.router.navigate('/payment-return/', obj);
            $update();
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function handleSubmit() {
      return _ref6.apply(this, arguments);
    };
  }();
  var borrowerCancels = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            $f7.dialog.confirm(locale.translate('loan.payment.confirmCancel'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              var formData, result;
              return _regeneratorRuntime.wrap(function (_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    formData = new FormData();
                    formData.append("CarLoanId", data.CarLoanData.CarLoanId);
                    formData.append("CarId", data.CarMainData.CarId);
                    formData.append("LenderId", data.CarMainData.ContactId);
                    formData.append("BorrowerId", data.CarLoanData.BorrowerId);
                    _context6.next = 1;
                    return carLoan.dispatch('borrowerCancels', formData);
                  case 1:
                    result = _context6.sent;
                    if (!(result.status !== undefined && result.status !== 200)) {
                      _context6.next = 2;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context6.abrupt("return");
                  case 2:
                    $f7.toast.show({
                      text: locale.translate('loan.payment.messageCancel')
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadCurrent: true,
                      ignoreCache: true
                    });
                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6);
            })));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function borrowerCancels() {
      return _ref7.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab" id="tab-3-payment">
  <div class="block">
    ${props.data.CarLoanData.CarLoanStatusId == 2 && $h`
    <div class="block block-strong">
      <div class="block justify-content-center" style="max-width: 340px;margin: auto;">
        <p>${locale.translate('loan.request.invoice.details')}:</p>
        ${invoiceDetails.length > 0 && $h`
        ${invoiceDetails.map((item) => $h`
        <div class="grid grid-cols-2 medium-grid-cols-2 xsmall-grid-cols-2 grid-gap">
          <div>${item.LanguageKeyValue}: </div> <div class="text-align-right">${item.ConceptCost}€</div>
        </div>
        `)}
        `}
      </div>
      <${UserSignArea} @checkSignedImage=${verifyImage} user-first-name=${data.DriverData.ContactName} user-last-name=${data.DriverData.ContactFirstLastName} prefix-area='lender' />
      <div class="block-title">${locale.translate('loan.payment.title')}</div>
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div>
          <a href="#" class="button button-fill button-raised color-red" @click="${borrowerCancels}">
            <span class="material-symbols-outlined">close</span>${locale.translate('general.decline')}
          </a>
        </div>
        <div></div>
        <div>
          <a href="#" class="button button-fill button-raised" @click="${openPaymentPopup}">
            <i class="icon material-symbols-outlined">euro</i>${locale.translate('loan.payment.goPay')}
          </a>
        </div>
      </p>
    </div>
    `}
  </div>
  <div class="popup payment-popup" @popup:open=${onPopUpOpen} @popup:close=${onPopUpClose}>
    <div class="page">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${locale.translate('loan.payment.popupTitle')}</div>
          <div class="right">
            <a class="link popup-close">
              <i class="icon material-symbols-outlined color-red">cancel</i>
            </a>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div class="block block-strong">
          <form id="payment-form">
            <div id="payment-element">
              <!-- Elements will create form elements here -->
            </div>
          </form>
          <br />
          <div>
            <a href="#" class="button button-fill button-raised color-blue" @click="${handleSubmit}">
              <i class="icon material-symbols-outlined">credit_card</i>${locale.translate('general.pay')} €${data.CarLoanData.TotalToPay}
            </a>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
};
export default PaymentTab;